<div tabindex="-1" #topElement></div>
<a class="bofa--skiplink" href="javascript:void(0);" (focusout)="onFocusOutMainContent($event)"
  (focus)="onFocusMainContent($event)" (keyup.enter)="onClickGoToMainContent($event)"
  (click)="onClickGoToMainContent($event)">Skip to main content</a>

<header class="wrapper level has-padding is-taller zoom-padding">
  <h1 class="bofa--heading is-3 has-no-margin zoom-font remove-outline header-width">
    Background check</h1>
  <img class="bofa_logo zoom-img-width zoom-img-height" src="assets/BofA-logo.svg" alt="A Bank of America application"
    width="240" role="img" />
</header>